<template>
  <div
    class="report-customer-purchased"
    :class="{ 'blur--content': isLoading }"
  >
    <h1 class="text-center">Customer List by Purchased Product</h1>
    <div class="row">
      <div class="col customer-list-filter-col">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
          style="margin: 0.6rem 0"
        ></BrandDropdown>
        <div v-if="isSubmit && error.errorBrand" class="text-error">
          {{ error.errorBrand.message }}
        </div>
      </div>
      <div class="col customer-list-filter-col">
        <label for="startDate" required>Start date</label>
        <date-picker
          id="startDate"
          v-bind="$attrs"
          v-model="startDate"
          format="D MMMM yyyy"
          lang="en"
          :value="startDate"
          @change="
            changeStartDate($event);
            startDate = $event;
          "
        />
        <div v-if="isSubmit && error.errorStartDate" class="text-error">
          {{ error.errorStartDate.message }}
        </div>
      </div>
      <div class="col customer-list-filter-col">
        <label for="endDate" required>End date</label>
        <date-picker
          id="endDate"
          v-bind="$attrs"
          v-model="endDate"
          format="D MMMM yyyy"
          lang="en"
          :value="endDate"
          :minDate="startDate"
          @change="endDate = $event"
        />
        <div v-if="isSubmit && error.errorEndDate" class="text-error">
          {{ error.errorEndDate.message }}
        </div>
      </div>
      <div class="col customer-list-filter-col">
        <label for="counterSelected">Counter name</label>
        <multiselect
          id="counterSelected"
          v-model="counterSelected"
          :options="counters"
          label="text"
          track-by="id"
          placeholder="All stores"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
    </div>
    <div class="row pb-4">
      <div class="col customer-list-filter-col">
        <div class="label-title">Product category conditions</div>
      </div>
    </div>
    <div class="row">
      <div class="col customer-list-filter-col">
        <label for="productLineSelected">Product line name (Cat 1)</label>
        <multiselect
          id="productLineSelected"
          v-model="productLineSelected"
          :options="productLines"
          label="text"
          track-by="id"
          placeholder="เลือก 1 Product Line"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
      <div class="col customer-list-filter-col">
        <label for="productCategorySelected"
          >Product category name (Cat 2)</label
        >
        <multiselect
          id="productCategorySelected"
          v-model="productCategorySelected"
          :options="productCategories"
          label="text"
          track-by="id"
          placeholder="เลือก 1 Product Category"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
      <div class="col customer-list-filter-col">
        <label for="productSubCategorySelected"
          >Product sub-category name (Cat 3)</label
        >
        <multiselect
          id="productSubCategorySelected"
          v-model="productSubCategorySelected"
          :options="productSubCategories"
          label="text"
          track-by="id"
          placeholder="เลือก 1 Product Sub Category"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
      <div class="col customer-list-filter-col">
        <label for="productSegmentSelected">Product segment name (Cat 4)</label>
        <multiselect
          id="productSegmentSelected"
          v-model="productSegmentSelected"
          :options="productSegments"
          label="text"
          track-by="id"
          placeholder="เลือก 1 Product Segment"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
    </div>
    <div class="row">
      <div class="col customer-list-filter-col">
        <label for="productTypeSelected">Product type name (Cat 5)</label>
        <multiselect
          id="productTypeSelected"
          v-model="productTypeSelected"
          :options="productTypes"
          label="text"
          track-by="id"
          placeholder="เลือก 1 Product Type"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
      <div class="col customer-list-filter-col"></div>
      <div class="col customer-list-filter-col"></div>
      <div class="col customer-list-filter-col"></div>
    </div>
    <div class="row pb-2">
      <div class="col customer-list-filter-col">
        <div class="label-title">Product conditions</div>
      </div>
    </div>
    <div class="row pb-3">
      <div class="col customer-list-filter-col">
        <div class="product-selection-note">
          *สินค้าที่เลือกในรายงาน หากเลือกสินค้ามากกว่า1 รายการ หมายถึง
          รายงานจะแสดงรายการซื้อของลูกค้าที่ซื้อสินค้าที่กำหนดทั้งหมดในบิลเดียว
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col customer-list-filter-col">
        <label for="product1">Product name 1</label>
        <multiselect
          id="product1"
          v-model="product1"
          :options="products"
          label="text"
          track-by="id"
          placeholder="เลือก 1 Product"
          style="margin: 0.6rem 0"
          class="product-multiselect"
        >
        </multiselect>
      </div>
      <div class="col customer-list-filter-col">
        <label for="product2">Product name 2</label>
        <multiselect
          id="product2"
          v-model="product2"
          :options="products"
          label="text"
          track-by="id"
          placeholder="เลือก 1 Product"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
    </div>
    <div class="row">
      <div class="col customer-list-filter-col">
        <label for="product3">Product name 3</label>
        <multiselect
          id="product3"
          v-model="product3"
          :options="products"
          label="text"
          track-by="id"
          placeholder="เลือก 1 Product"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
      <div class="col customer-list-filter-col">
        <label for="product4">Product name 4</label>
        <multiselect
          id="product4"
          v-model="product4"
          :options="products"
          label="text"
          track-by="id"
          placeholder="เลือก 1 Product"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
    </div>
    <div class="row">
      <div class="col customer-list-filter-col">
        <label for="product5">Product name 5</label>
        <multiselect
          id="product5"
          v-model="product5"
          :options="products"
          label="text"
          track-by="id"
          placeholder="เลือก 1 Product"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
      <div class="col customer-list-filter-col"></div>
    </div>
    <div class="row pb-4">
      <div class="col customer-list-filter-col">
        <div class="label-title">Purchase option</div>
      </div>
    </div>
    <div class="row">
      <div class="col customer-list-filter-col">
        <div class="form-check form-check-inline">
          <input
            class="form-check-input mr-2"
            v-model="isIncludePurchaseItems"
            id="purchasedItems"
            type="checkbox"
          />
          <label class="form-check-label" for="purchasedItems"
            >Purchased items</label
          >
        </div>
        <div
          v-if="isSubmit && error.errorIsIncludePurchaseItems"
          class="text-error"
        >
          {{ error.errorIsIncludePurchaseItems.message }}
        </div>
      </div>
      <div class="col customer-list-filter-col">
        <div class="form-check form-check-inline">
          <input
            class="form-check-input mr-2"
            v-model="isIncludeFreeItems"
            id="freeItems"
            type="checkbox"
          />
          <label class="form-check-label" for="freeItems">Free items</label>
        </div>
        <div
          v-if="isSubmit && error.errorIsIncludeFreeItems"
          class="text-error"
        >
          {{ error.errorIsIncludeFreeItems.message }}
        </div>
      </div>
      <div class="col customer-list-filter-col"></div>
      <div class="col customer-list-filter-col"></div>
      <div class="col customer-list-filter-col"></div>
    </div>
    <div class="row text-right">
      <div class="col align-self-center">
        <button
          class="btn btn-outline-primary"
          style="width: 100%; max-width: 131px"
          @click="getCustomerPurchasedList"
        >
          OK
        </button>
      </div>
    </div>
    <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
    ></v-progress-circular>
    <div v-if="!isLoading && listData.length > 0" class="table-crm mt-3">
      <div class="text-right">
        <button
          class="btn btn-outline-dark export-btn"
          :disabled="listData.length <= 0"
          @click="exportExcel"
        >
          Export to excel
        </button>
      </div>
      <b-table
        class="table table-bordered w-100 report-table"
        hover
        responsive
        :items="listData"
        :fields="fields"
      >
        <template #cell(customerCode)="data">
          <div class="text-left">
            {{ data.item.customerCode }}
          </div>
        </template>
        <template #cell(storeName)="data">
          <div class="text-left">
            {{ data.item.storeName }}
          </div>
        </template>
        <template #cell(orderNumber)="data">
          <div class="text-left">
            {{ data.item.orderNumber }}
          </div>
        </template>
        <template #cell(parentCodes)="data">
          <div class="text-left">
            {{ data.item.parentCodes }}
          </div>
        </template>
        <template #cell(totalQty)="data">
          <div class="text-right">
            {{ data.item.totalQty.toLocaleString() }}
          </div>
        </template>
        <template #cell(totalAmount)="data">
          <div class="text-right">
            {{ data.item.totalAmount.toLocaleString() }}
          </div>
        </template>
      </b-table>
    </div>
    <div class="pt-15" v-if="!isLoading && listData.length <= 0 && message">
      <h1 class="text-center">{{ message }}</h1>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import ExcelJS from "exceljs";
import downloadExcel from "@/views/Reports/downloadExcel";
import fields from "@/json/reports/fields_customer_purchased.json";
import BrandDropdown from "components/Brand/BrandDropdown";
import StoreService from "services/api/store.service";
import ProductLineService from "services/api/productLine.service";
import ProductCategoryService from "services/api/productCategory.service";
import ProductSubCategoryService from "services/api/productSubCategory.service";
import ProductSegmentService from "services/api/productSegment.service";
import ProductTypeService from "services/api/productType.service";
import ProductService from "services/api/product.service";
import ReportService from "services/api/report.service";

export default {
  components: {
    BrandDropdown,
  },
  data() {
    return {
      brandSelected: null,
      selectedBrandId: null,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      counters: [],
      counterSelected: null,
      productLines: [],
      productLineSelected: null,
      productCategories: [],
      productCategorySelected: null,
      productSubCategories: [],
      productSubCategorySelected: null,
      productSegments: [],
      productSegmentSelected: null,
      productTypes: [],
      productTypeSelected: null,
      products: [],
      product1: null,
      product2: null,
      product3: null,
      product4: null,
      product5: null,
      isIncludePurchaseItems: false,
      isIncludeFreeItems: false,
      listData: [],
      fileName: `customer_list_by_purchased_product_${moment().format(
        "YYYYMMDDHHmmss"
      )}`,
      fields: fields,
      isLoading: false,
      isSubmit: false,
      message: null,
      error: {
        errorBrand: null,
        errorStartDate: null,
        errorEndDate: null,
        errorIsIncludeFreeItems: null,
        errorIsIncludePurchaseItems: null,
      },
    };
  },
  methods: {
    setBrand(brand) {
      this.brandSelected = brand || "";
      this.selectedBrandId = brand ? brand.id : "";
      this.bindingData();
    },
    bindingData() {
      this.counterSelected = null;
      this.productLineSelected = null;
      this.productCategorySelected = null;
      this.productSubCategorySelected = null;
      this.productSegmentSelected = null;
      this.productTypeSelected = null;
      this.product1 = null;
      this.product2 = null;
      this.product3 = null;
      this.product4 = null;
      this.product5 = null;
      this.getCounters();
      this.getProductLines();
      this.getProductCategories();
      this.getProductSubCategories();
      this.getProductSegments();
      this.getProductTypes();
      this.getProducts();
    },
    async getCounters() {
      const params = {
        sortColumn: "name",
        sortType: "desc",
        brands: this.selectedBrandId ? [this.selectedBrandId] : []
      };
      await StoreService.getListStore(params)
        .then((res) => {
          const data = res.data;
          this.counters = data.store.map((s) => {
            return {
              id: s.storeCode,
              text: s.storeName,
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getProductLines() {
      const params = {
        brand: this.selectedBrandId,
      };
      await ProductLineService.getListProductLine(params)
        .then((res) => {
          const data = res.data;
          this.productLines = data.products.map((s) => {
            return {
              id: s.productLineCode,
              text: s.productLineName,
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getProductCategories() {
      const params = {
        brand: this.selectedBrandId,
      };
      await ProductCategoryService.getListProductCategory(params)
        .then((res) => {
          const data = res.data;
          this.productCategories = data.products.map((s) => {
            return {
              id: s.ProductCategoryCode,
              text: s.ProductCategoryName,
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getProductSubCategories() {
      const params = {
        brand: this.selectedBrandId,
      };
      await ProductSubCategoryService.getListProductSubCategory(params)
        .then((res) => {
          const data = res.data;
          this.productSubCategories = data.products.map((s) => {
            return {
              id: s.productSubCategoryCode,
              text: s.productSubCategoryName,
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getProductSegments() {
      const params = {
        brand: this.selectedBrandId,
      };
      await ProductSegmentService.getListProductSegment(params)
        .then((res) => {
          const data = res.data;
          this.productSegments = data.products.map((s) => {
            return {
              id: s.productSegmentCode,
              text: s.productSegmentName,
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getProductTypes() {
      const params = {
        brand: this.selectedBrandId,
      };
      await ProductTypeService.getListProductType(params)
        .then((res) => {
          const data = res.data;
          this.productTypes = data.products.map((s) => {
            return {
              id: s.productTypesCode,
              text: s.productTypesName,
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getProducts() {
      const params = {
        brand: this.selectedBrandId,
      };
      await ProductService.getListProducts(params)
        .then((res) => {
          const data = res.data;
          this.products = data.product.map((s) => {
            return {
              id: s.productCode,
              text: s.productNameWithParentCode
                ? s.productNameWithParentCode
                : s.productName,
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    changeStartDate(val) {
      if (val > this.endDate) {
        this.endDate = null;
      }
    },
    getParams() {
      return {
        brand: this.selectedBrandId,
        startDate: this.startDate,
        endDate: this.endDate,
        counterName: this.counterSelected ? this.counterSelected.text : null,
        productLineCode: this.productLineSelected
          ? this.productLineSelected.id
          : null,
        productCategoryCode: this.productCategorySelected
          ? this.productCategorySelected.id
          : null,
        productSubCategoryCode: this.productSubCategorySelected
          ? this.productSubCategorySelected.id
          : null,
        productSegmentCode: this.productSegmentSelected
          ? this.productSegmentSelected.id
          : null,
        productTypeCode: this.productTypeSelected
          ? this.productTypeSelected.id
          : null,
        productCode1: this.product1 ? this.product1.id : null,
        productCode2: this.product2 ? this.product2.id : null,
        productCode3: this.product3 ? this.product3.id : null,
        productCode4: this.product4 ? this.product4.id : null,
        productCode5: this.product5 ? this.product5.id : null,
        isIncludePurchaseItems: this.isIncludePurchaseItems,
        isIncludeFreeItems: this.isIncludeFreeItems,
      };
    },
    async getCustomerPurchasedList() {
      this.isSubmit = true;
      this.isLoading = true;
      await ReportService.getCustomerListByPurchasedProduct(this.getParams())
        .then((res) => {
          this.isLoading = false;
          this.resetErrorText();
          const data = res.data;
          this.listData = data.products;
          if (data.products.length <= 0) {
            this.message = data.message;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.resetErrorText();
          this.listData = [];
          const errorData = err.response?.data;
          if (errorData.errors?.length > 0) {
            this.setErrorText(errorData.errors);
            return;
          }
          if (errorData.message) {
            this.showDialog = true;
            this.message = errorData.message;
          }
        });
    },
    setErrorText(errors) {
      this.error.errorBrand = errors.find((e) => e.fieldName === "brand");
      this.error.errorStartDate = errors.find((e) => e.fieldName === "year");
      this.error.errorEndDate = errors.find((e) => e.fieldName === "month");
      this.error.errorEndDate = errors.find((e) => e.fieldName === "endDate");
      this.error.errorIsIncludePurchaseItems = errors.find(
        (e) => e.fieldName === "isIncludePurchaseItems, isIncludeFreeItems"
      );
      this.error.errorIsIncludeFreeItems = errors.find(
        (e) => e.fieldName === "isIncludePurchaseItems, isIncludeFreeItems"
      );
    },
    resetErrorText() {
      this.error.errorBrand = null;
      this.error.errorStartDate = null;
      this.error.errorEndDate = null;
      this.error.errorIsIncludePurchaseItems = null;
      this.error.errorIsIncludeFreeItems = null;
    },
    exportExcel() {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Sheet 1");
      sheet.columns = this.fields.map((f) => {
        return {
          key: f.key,
          header: f.header,
        };
      });
      this.listData.forEach((item) => {
        sheet.addRow({
          customerCode: item.customerCode,
          storeName: item.storeName,
          orderNumber: item.orderNumber,
          parentCodes: item.parentCodes,
          totalQty: item.totalQty,
          totalAmount: item.totalAmount,
        });
      });

      //get column
      const customerCodeCol = sheet.getColumn("customerCode");
      const storeNameCol = sheet.getColumn("storeName");
      const orderNumberCol = sheet.getColumn("orderNumber");
      const parentCodes = sheet.getColumn("parentCodes");
      const totalQtyComma = sheet.getColumn("totalQty");
      const totalAmountComma = sheet.getColumn("totalAmount");

      //set thousand separator
      totalQtyComma.numFmt = "#,###0";
      totalAmountComma.numFmt = "#,###0.00";

      //set width
      customerCodeCol.width = 20;
      storeNameCol.width = 30;
      orderNumberCol.width = 20;
      parentCodes.width = 50;
      totalQtyComma.width = 10;
      totalAmountComma.width = 15;

      //set wrap text
      customerCodeCol.alignment = { wrapText: true };
      storeNameCol.alignment = { wrapText: true };
      orderNumberCol.alignment = { wrapText: true };
      parentCodes.alignment = { wrapText: true };
      totalQtyComma.alignment = { wrapText: true };
      totalAmountComma.alignment = { wrapText: true };

      workbook.xlsx
        .writeBuffer()
        .then((res) => {
          downloadExcel.downloadFile(res, this.fileName);
        })
        .catch((ex) => console.log("Error: ", ex));
    },
  },
  watch: {
    brandSelected(val) {
      if (val) {
        this.selectedBrandId = val.id;
      }
      this.getCounters();
      this.getProductLines();
      this.getProductCategories();
      this.getProductSubCategories();
      this.getProductSegments();
      this.getProductTypes();
      this.getProducts();
    },
  },
};
</script>
<style lang="scss" scoped>
label[required]::after {
  content: "*";
  color: red;
  margin-left: 5px;
}
.label-title {
  font-weight: bold;
  margin-bottom: 0;
  padding-top: 20px;
}

.product-selection-note {
  color: red;
}

.customer-list-filter-col {
  padding: 0 7px !important;
}
.blur--content {
  filter: blur(2px);
  pointer-events: none;
}
.export-btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  border: 1px solid #212529;
  background-color: transparent;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
}
.report-table {
  ::v-deep thead {
    tr {
      th {
        vertical-align: middle;
      }
    }
  }
  ::v-deep tbody {
    tr {
      td {
        max-width: 12rem !important;
        word-wrap: break-word;
      }
    }
  }
}
.export-btn:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
</style>
